import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import {
	GlobalStyle,
	GrainOverlay,
	themeDark,
	themeLight,
} from '@quizzach/styles';
import AnimatedRoutes from './AnimatedRoutes';
import {
	AuthProvider,
	CartProvider,
	useThemeContext,
	WindowListenerProvider,
	CookieConsentProvider,
} from '@quizzach/contexts';
import {
	CookieConsentModal,
	GlobalFooter,
	ScrollToTop,
	ToastProvider,
	// CanonicalTag,
	// SeoTags,
} from '@quizzach/components';

function App() {
	const { theme, themeOverride } = useThemeContext();
	const activeTheme = themeOverride ?? theme;
	const resolvedTheme = activeTheme === 'light' ? themeLight : themeDark;

	return (
		<StyleSheetManager shouldForwardProp={(prop: any) => prop !== 'severity'}>
			<ThemeProvider theme={resolvedTheme}>
				<GlobalStyle />
				<GrainOverlay aria-hidden />
				<WindowListenerProvider>
					<BrowserRouter>
						{/* Each route starts at the top, before first paint. */}
						<ScrollToTop />
						{/* <CanonicalTag /> */}
						{/* <SeoTags /> */}
						<CookieConsentProvider>
							<AuthProvider>
								<CartProvider>
									<ToastProvider>
										<AnimatedRoutes />
										<GlobalFooter />
										<CookieConsentModal />
									</ToastProvider>
								</CartProvider>
							</AuthProvider>
						</CookieConsentProvider>
					</BrowserRouter>
				</WindowListenerProvider>
			</ThemeProvider>
		</StyleSheetManager>
	);
}

export default App;
